export class NameValue {
  name!: string;
  value!: string;
}
export class NameValueNumber {
  name!: string;
  value!: number;
}
export interface INameId {
  name: string;
  id: string;
}

export class GeneralUISetting {
  viewMode: string = "normal";
}
